<template>
  <div class="report-mobile">
    <div class="report-mobile__filters">
      <slot name="filters" />
    </div>

    <div class="report-mobile__body" :class="{ 'report-mobile__body--has-action': hasActionSlot }">
      <div v-if="loading" class="report-mobile__loading">
        <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
      </div>

      <div v-else-if="empty" class="report-mobile__empty">
        <v-icon size="32" color="grey">mdi-database-off-outline</v-icon>
        <p>{{ emptyText }}</p>
      </div>

      <slot v-else />
    </div>

    <div v-if="hasActionSlot" class="report-mobile__action">
      <slot name="action" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportMobileFrame',
  props: {
    loading: { type: Boolean, default: false },
    empty: { type: Boolean, default: false },
    emptyText: { type: String, default: 'No data available for the selected range.' }
  },
  data() {
    return {
      hasActionSlot: false
    };
  },
  mounted() {
    this.hasActionSlot = !!this.$slots.action;
  },
  updated() {
    const next = !!this.$slots.action;
    if (next !== this.hasActionSlot) this.hasActionSlot = next;
  }
};
</script>

<style lang="scss" scoped>
.report-mobile {
  display: flex;
  flex-direction: column;
  margin: -16px -16px 0;
  min-height: calc(100vh - 64px);
}

.report-mobile__filters {
  background: var(--app-surface);
  border-bottom: 1px solid var(--app-border);
  padding: 12px;
  position: sticky;
  top: 64px;
  width: 100%;
  z-index: 3;
}

@media (min-width: 600px) {
  .report-mobile__filters {
    top: 72px;
  }
}

.report-mobile__body {
  background: var(--app-surface);
  flex: 1;
  max-width: 100%;
  width: 100%;
}

.report-mobile__body--has-action {
  padding-bottom: 96px;
}

.report-mobile__loading,
.report-mobile__empty {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  padding: 48px 16px;
}

.report-mobile__empty p {
  color: var(--app-text-muted);
  font-size: 14px;
  margin: 0;
}

.report-mobile__action {
  background: var(--app-surface);
  border-top: 1px solid var(--app-border);
  bottom: 0;
  box-shadow: 0 -8px 20px rgba(15, 23, 42, 0.06);
  left: 0;
  padding: 12px;
  position: fixed;
  right: 0;
  z-index: 4;
}
</style>
